<div class="checkbox-container" (click)="toggleChecked()">
  <div class="checkbox border border-gray-300" [class.checked]="checked">
    @if (checked) {
      <i class="fa-solid fa-check text-white fa-xs mt-0.5"></i>
    }
  </div>
</div>
